export enum GoalStatus {
  Archived = 'archived',
  Completed = 'completed',
}
